import { type FormRule } from 'antd';

/**
 * Types
 */

export type FieldError = {
  defaultMessage: String;
  objectName: String;
  field: String;
  bindingFailure: String;
};
export type ErrorResponse = {
  timestamp: Date;
  type: String;
  message: String;
  details: String;
  fieldErrors: FieldError[];
};

/**
 * Utils
 */

export const createValidation = <P>(rules: Record<keyof P, FormRule[]>) => rules;

function getTextWidth(text: any) {
  if (text == null) {
    return 0;
  }
  const canvas = document.createElement('canvas');
  const context: any = canvas.getContext('2d');
  const metrics = context.measureText(text);
  const width = Math.round(metrics.width + 120);
  return width;
}

export const calculateColumnsWidth = (columns: any, source: any[], maxWidthPerCell = 500) => {
  // First we calculate the width for each column
  // The column width is based on its string length

  const columnsWithWidth = columns.map((column: any) =>
    Object.assign(column, {
      width: getTextWidth(column.title),
    })
  );

  console.log(columnsWithWidth);

  // Since we have a minimum width (column's width already calculated),
  // now we are going to verify if the cell value is bigger
  // than the column width which is already set

  source.map((entry) => {
    columnsWithWidth.map((column: any, indexColumn: any) => {
      const columnWidth = column.width;
      const cellValue = entry[column.key];

      let cellWidth = 0;

      // Get the string width based on chars length
      if (cellValue != null) {
        cellWidth = getTextWidth(cellValue);
      }

      // console.log(indexColumn + " " + columnWidth + " " + cellValue + " " + cellWidth);

      // Verify if the cell value is smaller than column's width
      if (cellWidth < columnWidth) cellWidth = columnWidth;

      // Verify if the cell value width is bigger than our max width flag
      if (cellWidth > maxWidthPerCell) cellWidth = maxWidthPerCell;

      // Update the column width
      columnsWithWidth[indexColumn].width = cellWidth;
    });
  });

  // Sum of all columns width to determine the table max width
  const tableWidth = columnsWithWidth
    .map((column: any) => column.width)
    .reduce((a: any, b: any) => {
      return a + b;
    });

  return {
    columns: columnsWithWidth,
    source,
    tableWidth,
  };
};
